<template>
	<div class="main p34">
		<div class="my-title">批改信息</div>
		<div class="recognize-table mt10">
			<div>被保公司：{{ info.companyListString }}
				<Button style="margin-left: 20px;" type="primary" @click="companyEdit">编辑</Button>
			</div>
			<Row type="flex" justify="space-between" class="mt10">
				<Col span="2">
					<Button type="info" @click="addClick" v-if="isFirstTo25th && !isEndDateNotAfter25th">批增</Button>
				</Col>
				<Col span="22">
					<div class="red ml20" style="display: flex; font-size: 14px;">
						<span>注意：</span>
						<span>1、每月25号后，不允许批增和批减，只允许替换。<br />2、保障止期当天(不晚于25号)只允许批减，不允许批增和替换</span>
					</div>
				</Col>
			</Row>
			<el-table class="mt10" :data="orderData" border style="width: 100%">
				<el-table-column fixed prop="name" label="设备名称" width="100"></el-table-column>
				<el-table-column prop="code" label="车架号/发动机号" width="190"></el-table-column>
				<el-table-column prop="productFactory" label="生产厂家" width="150"></el-table-column>
				<el-table-column prop="useAddress" label="使用区域" width="150"></el-table-column>
				<el-table-column prop="feeBearGroup" label="费用承担主体" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="feeBearCode" label="费用承担主体编码" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="costBearCode" label="成本承担主体编码" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="price" label="保费变化" width="150"></el-table-column>
				<el-table-column prop="remark" label="备注" width="150">
					<template slot-scope="{ row }">
						<span :style="{ color: row.status == '0' ? '#333' : 'red' }">{{ row.remark }}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="130">
						<template slot-scope="scope">
							<!-- 批减：1-25号（包含保障止期当天）且不是被替换或已批减的设备 -->
							<a v-if="scope.row.status == '0' && (scope.row.remark!='批减'&&scope.row.remark!='被替换') && (isFirstTo25th || isEndDateNotAfter25th)" key="tuibao" @click="refund(scope.row,scope.$index)">批减</a>
							<!-- 替换：1-25号（排除保障止期当天）或26号至月底 -->
							<a v-if="scope.row.status == '0' && (scope.row.remark!='批减'&&scope.row.remark!='被替换') && ((isFirstTo25th && !isEndDateNotAfter25th) || isAfter25th)" key="tihuan" @click="openRelace(scope.row)">替换</a>
							<!-- 编辑：仅1-25号（排除保障止期当天） -->
							<a v-if="scope.row.status == '0' && isFirstTo25th && !isEndDateNotAfter25th" key="编辑" @click="openEdit(scope.row, scope.$index)">编辑</a>
							<a v-if="scope.row.status == '1'" key="shanchu" @click="delList(scope.row,scope.$index)">删除</a>
							<a v-if="scope.row.status == '2'" @click="recall(scope.row, scope.$index)" key="qxtihuan">取消替换</a>
							<a v-if="scope.row.status == '4'" @click="recall(scope.row, scope.$index)" key="qxtuibao">取消批减</a>
							<a v-if="scope.row.status == '5'" @click="recall(scope.row, scope.$index)" key="qxbianji">取消编辑</a>
						</template>
					</el-table-column>
			</el-table>
		</div>
		<div class="mt10 center">
			<Button type="success" @click="sub" :disabled="!canSub">立即批改</Button>
		</div>
		<Modal v-model="addShow" title="批增" width="800px" :mask-closable="false" scrollable>
			<Form :model="addForm" ref="addForm" :label-width="100" :rules="addFormRules">
				<FormItem label="新增方式">
					<RadioGroup v-model="radio" @on-change="radioChange">
						<Radio label="0">单个</Radio>
						<Radio label="1">批量</Radio>
					</RadioGroup>
				</FormItem>
				<div v-if="radio=='0'">
					<FormItem label="设备名称：" prop="name">
						<Input type="text" placeholder="请输入设备名称" v-model="addForm.name"></Input>
					</FormItem>
					<FormItem label="车架号/发动机号：" prop="code">
						<Input type="text" placeholder="请输入车架号/发动机号" v-model="addForm.code"></Input>
					</FormItem>
					<FormItem label="生产厂家：" prop="productFactory">
						<Input type="text" placeholder="请输入生产厂家" v-model="addForm.productFactory"></Input>
					</FormItem>
					<FormItem label="使用区域：" prop="useAddress">
						<Input type="text" placeholder="请输入使用区域" v-model="addForm.useAddress"></Input>
					</FormItem>
					<FormItem label="费用承担主体" prop="feeBearGroup">
						<Select v-model="addForm.feeBearGroup" placeholder="请选择费用承担主体" filterable transfer @on-change="structureChange">
							<Option :value="item.feeBearGroup" v-for="(item, index) in structureList" :key="index">{{ item.feeBearGroup }}</Option>
						</Select>
					</FormItem>
					<FormItem label="费用承担主体编码" prop="feeBearCode">
						<Select v-model="addForm.feeBearCode" placeholder="请选择费用承担主体编码" filterable transfer>
						<Option :value="item.code" v-for="(item, index) in feeBearList" :key="index">{{ item.code }}</Option>
					</Select>
					</FormItem>
					<FormItem label="成本承担主体编码" prop="costBearCode">
						<Select v-model="addForm.costBearCode" placeholder="请选择成本承担主体编码" filterable transfer>
							<Option :value="item.code" v-for="(item, index) in costBearList" :key="index">{{ item.code }}</Option>
						</Select>
					</FormItem>
				</div>
				<div v-if="radio=='1'">
					<div class="fixed-bottom">
						<span>参保车辆：</span>
						<UploadFile
							ref="uploadFile"
							style="display:inline-block"
							url="/pc/specialEquipment/add/import"
							:show-upload-list="false"
							btn-text="上传车辆"
							@on-success="uploadSuccessList" 
							@on-file="filesName"
						/>
						点击<a @click="download">下载</a>批单模板&nbsp;&nbsp;
						<!-- <Button v-if="files.name" type="error" @click="deleteFile">清空设备信息</Button> -->
					</div>
					<el-table class="mt10" :data="list" border style="width: 100%">
						<el-table-column fixed prop="name" label="*设备名称" width="100"></el-table-column>
						<el-table-column prop="code" label="*车架号/发动机号" width="190"></el-table-column>
						<el-table-column prop="productFactory" label="生产厂家" width="150"></el-table-column>
						<el-table-column prop="useAddress" label="使用区域" width="150"></el-table-column>
						<el-table-column prop="feeBearGroup" label="*费用承担主体" show-overflow-tooltip width="150"></el-table-column>
						<el-table-column prop="feeBearCode" label="*费用承担主体编码" show-overflow-tooltip width="150"></el-table-column>
						<el-table-column prop="costBearCode" label="*成本承担主体编码" show-overflow-tooltip width="150"></el-table-column>		
					</el-table>
				</div>
			</Form>
			<template slot="footer">
				<Button type="text" @click="addCancel">取消</Button>
				<Button type="primary" v-if="radio=='1'" :disabled="list.length==0" @click.native="confirmAdd">确定</Button>
				<Button type="primary" v-else @click.native="confirmAdd">确定</Button>
			</template>
		</Modal>
		<Modal v-model="editShow" title="编辑被保公司" width="600px" :mask-closable="false" scrollable>
			<Form :model="editForm" ref="editForm" :label-width="100" @submit.native.prevent>
				<FormItem prop="companyList">
					<template slot="label">
						<span style="color: #ed4014;margin-right: 4px;">*</span>被保公司
					</template>
					<div v-for="(company, index) in editForm.companyList" :key="index" style="margin-bottom: 20px;">
						<FormItem :prop="'companyList.' + index + '.name'"
						:rules="{required: true, message: '请输入被保公司', trigger: 'blur'}" >
							<div v-if="index === 0" style="display: flex; align-items: center;">
								<Input type="text" v-model="company.name" :disabled="index === 0" placeholder="请输入被保公司名称" style="width: 300px;"></Input>
								<Button style="margin-left: 10px;" v-if="editForm.companyList.length < 5" type="primary" @click="addCompany">添加</Button>
							</div>
							<div v-else style="display: flex; align-items: center;">
								<Input type="text" v-model="company.name" :disabled="index === 0" placeholder="请输入被保公司名称" style="width: 300px;"></Input>
								<Button style="margin-left: 10px;" v-if="index > 0" type="error" @click="deleteCompany(index)">删除</Button>
							</div>
						</FormItem>
					</div>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="editShow = false">取消</Button>
				<Button type="primary" @click="confirmEdit">确定</Button>
			</template>
		</Modal>
		
		<!-- 编辑设备信息弹窗 -->
		<Modal v-model="editDeviceShow" title="编辑设备信息" width="600px" :mask-closable="false" @on-cancel="editCancel">
			<Form :model="editDeviceForm" ref="editDeviceForm" :label-width="100" :rules="editDeviceFormRules">
				<FormItem label="设备名称" prop="name">
					<Input type="text" placeholder="请输入设备名称" v-model="editDeviceForm.name"></Input>
				</FormItem>
				<FormItem label="设备编号" prop="code">
					<Input type="text" placeholder="请输入设备编号" v-model="editDeviceForm.code" disabled></Input>
				</FormItem>
				<FormItem label="生产厂家" prop="productFactory">
					<Input type="text" placeholder="请输入生产厂家" v-model="editDeviceForm.productFactory"></Input>
				</FormItem>
				<FormItem label="使用区域" prop="useAddress">
					<Input type="text" placeholder="请输入使用区域" v-model="editDeviceForm.useAddress"></Input>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="editCancel">取消</Button>
				<Button type="primary" :loading="editDeviceLoading" @click="confirmEditDevice">确定</Button>
			</template>
		</Modal>
		
		<Modal v-model="replaceShow" width="600px" title="替换" :mask-closable="false" scrollable>
			<Card title="原设备信息">
				<Form :label-width="90">
					<Row>
						<Col span="12">
						<FormItem label="设备名称：" class="mb0">
							{{ replaceData.name }}
						</FormItem>
						</Col>
						<Col span="12">
						<FormItem label="车架号/发动机号：" class="mb0">
							{{ replaceData.code }}
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="24">
						<FormItem label="生产厂家：" class="mb0">
							{{ replaceData.productFactory }}
						</FormItem>
						</Col>
						<Col span="24">
						<FormItem label="使用区域：" class="mb0">
							{{ replaceData.useAddress }}
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="24">
						<FormItem label="费用承担主体：" class="mb0">
							{{ replaceData.feeBearGroup }}
						</FormItem>
						</Col>
						<Col span="24">
						<FormItem label="费用承担主体编码：" class="mb0">
							{{ replaceData.feeBearCode }}
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="24">
							<FormItem label="成本承担主体：" class="mb0">
								{{ replaceData.costBearCode }}
							</FormItem>
						</Col>
					</Row>
				</Form>
			</Card>
			<Card title="替换后设备信息" class="mt10">
				<Form :model="replaceForm" ref="replaceForm" :label-width="80" :rules="replaceFormRules">
					<FormItem label="设备名称" prop="name">
						<Input type="text" v-model="replaceForm.name"></Input>
					</FormItem>
					<FormItem label="车架号/发动机号" prop="code">
						<Input type="text" v-model="replaceForm.code"></Input>
					</FormItem>
					<FormItem label="生产厂家" prop="productFactory">
						<Input type="text" v-model="replaceForm.productFactory"></Input>
					</FormItem>
					<FormItem label="使用区域" prop="useAddress">
						<Input type="text" v-model="replaceForm.useAddress"></Input>
					</FormItem>
					<FormItem label="费用承担主体" prop="feeBearGroup">
						<Select v-model="replaceForm.feeBearGroup" filterable transfer @on-change="structureChange">
							<Option :value="item.feeBearGroup" v-for="(item, index) in structureList" :key="index">{{ item.feeBearGroup }}</Option>
						</Select>
					</FormItem>
					<FormItem label="费用承担主体编码" prop="feeBearCode">
						<Select v-model="replaceForm.feeBearCode" filterable transfer>
						<Option :value="item.code" v-for="(item, index) in feeBearList" :key="index">{{ item.code }}</Option>
					</Select>
					</FormItem>
					<FormItem label="成本承担主体编码" prop="costBearCode">
						<Select v-model="replaceForm.costBearCode" filterable transfer>
							<Option :value="item.code" v-for="(item, index) in costBearList" :key="index">{{ item.code }}</Option>
						</Select>
					</FormItem>
				</Form>
			</Card>
			<template slot="footer">
				<Button type="text" @click="replaceShow = false">取消</Button>
				<Button type="primary" :loading="replaceLoading" @click="confirmReplace">确定</Button>
			</template>
		</Modal>
		<Modal v-model="confirmShow" title="上传批改单" width="400px" @on-cancel="confirmMedalCancel" :mask-closable="false" scrollable>
			<Form :label-width="130">
				<FormItem :label-width="20">
					本次编辑车辆，{{ amount >= 0 ? '合计需缴纳' : '合计需退回' }}
					{{ amount }}元
				</FormItem>
				<FormItem label="下载批改单附件：">
					<a  @click.stop="downloadClick">点击下载</a>
				</FormItem>
				<FormItem label="上传盖章附件：">
					<UploadFileImg 
						@on-success="val=>uploadSuccess(val)" 
						:accept="['image']"
						type="select"
						btn-text="上传批改单"></UploadFileImg>
						<div v-if="correctUrlList.length>0">
							<p v-for="(item,index) in correctUrlList" :key="index">
								批改单{{index+1}}&nbsp;&nbsp;&nbsp;<a :href="item" target="_blank" class="ml10" :key="index">查看</a>&nbsp;<a style="color:#ed4014" @click="del(index)">删除</a>
							</p>
						</div>
						<div style="color: red;">请先下载附件，盖章后上传</div>
				</FormItem>
			</Form>
			<template slot="footer">
				<!-- <Button type="text" @click="confirmShow = false">关闭</Button> -->
				<Button type="primary" @click="confirmSub" :loading="confirmLoading">确定</Button>
			</template>
		</Modal>
		<!-- 批减确认弹窗 -->
		<Modal v-model="refundShow" title="确认退保" width="450px" :mask-closable="false">
			<Form :model="refundForm" ref="refundForm" :label-width="100">
				<FormItem label="设备名称：" class="mb0" required>
					{{ refundData.name }}
				</FormItem>
				<FormItem class="mt10" label="退保日期：" prop="refundDate" :rules="[{ required: true,type:'date', message: '请选择退保日期', trigger: 'change' }]">
					<DatePicker
						v-model="refundForm.refundDate"
						type="date"
						:options="refundDateOptions"
						placeholder="请选择退保日期"
						style="width: 100%"
					></DatePicker>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="refundShow = false">取消</Button>
				<Button type="primary" :loading="refundLoading" @click="confirmRefund">确定</Button>
			</template>
		</Modal>

		<TrackNotice :companyName="this.info.subjectName" />
	</div>
</template>
<script>
import UploadFile from '../common/UploadFile'
import UploadFileImg from '@/components/common/UploadFileImg'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components: {UploadFile, UploadFileImg,TrackNotice },
	mixins:[track],
	data() {
		return {
			radio:'0',
			replaceLoading: false,
			info: {},
			id: this.$route.params.id,
			orderData: [],
			list:[],
			addShow: false,
			addForm: {},
			addFormRules: {
				name:{ required: true, message: '请输入设备名称', trigger: 'blur' },
				code:[{ required: true, message: '请输入车架号/发动机号', trigger: 'blur' },{ pattern: this.rules.alphanumeric, message: '格式不正确', trigger: 'blur' }
    			],
				productFactory:{ required: true, message: '请输入生产厂家', trigger: 'blur' },
				useAddress:{ required: true, message: '请输入使用区域', trigger: 'blur' },
				feeBearGroup:{ required: true, message: '请选择费用承担主体', trigger: 'change' },
				feeBearCode:{ required: true, message: '请选择费用承担主体编码', trigger: 'change' },
				costBearCode:{ required: true, message: '请选择成本承担主体编码', trigger: 'change' }	
			},
			editShow: false,
			editForm: {
				companyList: []
			},
			replaceShow: false,
			replaceData: {},
			replaceForm: {},
			replaceFormRules: {
				name:{ required: true, message: '请输入设备名称', trigger: 'blur' },
				code:[{ required: true, message: '请输入车架号/发动机号', trigger: 'blur' },{ pattern: this.rules.alphanumeric, message: '格式不正确', trigger: 'blur' }
    			],
				productFactory:{ required: true, message: '请输入生产厂家', trigger: 'blur' },
				useAddress:{ required: true, message: '请输入使用区域', trigger: 'blur' },
				feeBearGroup:{ required: true, message: '请选择费用承担主体', trigger: 'change' },
				feeBearCode:{ required: true, message: '请选择费用承担主体编码', trigger: 'change' },
				costBearCode:{ required: true, message: '请选择成本承担主体编码', trigger: 'change' }	
			},
			// 编辑设备信息相关数据
			editDeviceLoading:false,
			editDeviceShow: false,
			editDeviceForm: {},
			editDeviceFormRules: {
				name:{ required: true, message: '请输入设备名称', trigger: 'blur' },
				code:{ required: true, message: '请输入设备编号', trigger: 'blur' },
				productFactory:{ required: true, message: '请输入生产厂家', trigger: 'blur' },
				useAddress:{ required: true, message: '请输入使用区域', trigger: 'blur' }
			},
			editDeviceIndex: -1,
			structureList: [], // 承担主体
			feeBearList:[], // 承担主体编码
			costBearList:[], // 成本承担主体编码
			timer:null,
			loading:false,
			originalList:[], // 原始数据
			confirmShow:false,
			correctUrlList: [],
			confirmLoading:false,
			amount:0,
			companyEdited: false, // 添加这个属性来跟踪被保公司是否被编辑
			// 批减相关
			refundShow: false,
			refundLoading: false,
			refundData: {},
			refundIndex: -1,
			refundForm: {
				refundDate: ''
			},
			refundDateOptions: {},
		}
	},
	computed: {
		canSub() {
			let list = this.orderData.filter(item => {
				return item.status != '0'&&item.status != '3'
			})
			// 修改逻辑：如果有设备变更或者被保公司被编辑过，就允许提交
			return list.length > 0 || this.companyEdited
		},
		uploadParams(){
			return JSON.stringify({
				beginDate: this.info.beginDate,
				endDate: this.info.endDate,
				policyTimeType: this.info.policyTimeType
			})
		},
		// 判断当前日期是否在1号至25号之间（包含25号）
		isFirstTo25th() {
			const today = new Date();
			const day = today.getDate();
			return day >= 1 && day <= 25;
		},
		// 判断当前日期是否在26号至月底
		isAfter25th() {
			const today = new Date();
			const day = today.getDate();
			const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
			return day >= 26 && day <= lastDayOfMonth;
		},
		// 判断是否为保障止期当天且不晚于25号
		isEndDateNotAfter25th() {
			if (!this.info.endDate) return false;
			const today = new Date();
			const endDate = new Date(this.info.endDate);
			const endDay = endDate.getDate();
			
			// 设置时间为当天的00:00:00进行比较
			today.setHours(0, 0, 0, 0);
			endDate.setHours(0, 0, 0, 0);
			
			return today.getTime() === endDate.getTime() && endDay <= 25;
		}
	},
	created() {
		this.getStructureList();
		this.getInfo();
	},
	mounted(){
		// 回溯 开始录制
		this.track_is_new = true;
		this.$nextTick(()=>{
			this.trackInit();
		})
	},
	beforeDestroy() {
		//在 beforeDestroy生命周期函数中销毁定时器
		clearInterval(this.timer);
		this.timer = null;
	},
	methods: {
		// 编辑被保公司
		companyEdit(){
			// 初始化被保公司列表
			if (this.info.companyListString) {
				const companies = this.info.companyListString.split(',').map(name => ({ name: name.trim() }));
				this.editForm.companyList = companies;
			} else {
				this.editForm.companyList = [{ name: '' }];
			}
			this.editShow = true;
		},
		download() {
			this.exportToExcel('/specialEquipment/insurance/devices/template')
		},
		radioChange(){
			this.addForm = {};
			this.list = [];
		},
		downloadClick(){
			let list = this.jsonCopy(this.orderData.filter(item => {
				return item.status == '1' || item.status == '2' || item.status == '3' || item.status == '4'|| item.status == '5'
			}))
			this.$axios.post('/specialEquipment/insurance/changeBillDownload.json',{
				policyNo: this.id,
				policyScrip: this.info.policyScrip,
				companyListString: this.info.companyListString,
				details: list
			}).then(res=>{
				if(res){
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '保险合同变更申请书')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		},
		// 承担主体选中 级联费用承担主体编码，成本承担主体编码
		structureChange(val){
			if(val){
				this.$set(this.addForm,'feeBearCode','');
				this.$set(this.addForm,'costBearCode','');
				this.structureList.forEach(item=>{
					if(item.feeBearGroup==val){
						this.feeBearList = item.feeBearList; // 费用承担主体编码
						this.costBearList = item.costBearList; // 成本承担主体
					}
				})
			}
		},
		// 承担主体选中 级联费用承担主体编码，成本承担主体编码
		feeBearGroupChange(val){
			this.formValidate.feeBearCode = '';
			this.formValidate.costBearCode = '';
			this.feeBearList = val.feeBearList; // 费用承担主体编码
			this.costBearList = val.costBearList; // 成本承担主体
		},
		//获取承担主体
		getStructureList() {
			this.$axios.post('/specialEquipment/feeBear/structure.json').then((res) => {
				this.structureList = res
			})
		},
		// 文件名
		filesName(file){
			this.files = file;
		},
		/*上传成功后获取数据*/
		uploadSuccessList (res) {
			if(res.code==10000000){
				this.list = res.data;
			}else{
				this.alert(res.msg)
			}
		},
		/*上传成功后获取数据*/
		uploadSuccess(res) {
			if (this.correctUrlList.length < 5) {
				this.correctUrlList.push(res.url)
			} else {
				this.alert('最多上传5张批改单！')
			}
		},
		// 删除
		deleteFile(){
			this.confirm('确定删除该文件？',()=>{
				this.files = {};
				this.$refs.uploadFile.removeFile();
			})
		},
		/*获取保单信息*/
		async getInfo() {
			this.loading = true;
			let obj = { policyNo: this.id }
			let res = await this.$axios.post('/specialEquipment/policy/detail.json', obj)
			this.info = res;
			let list = res.detailList.map(item => {
				item.status = '0'
				return item
			})
			this.orderData = list;
			this.originalList = this.jsonCopy(res.detailList); // 原保单数据
		},
		checkCode(code) {
			let index = this.orderData.findIndex(item => {
				return item.status != '4' && item.status != '2' && item.code == code
			})
			if (index > -1) {
				this.alert('车架号/发动机号与列表设备重复')
				return false
			} else {
				return true
			}
		},
		// 添加
		addClick() {
			this.addShow = true;
			this.addForm = {};
			this.$refs.addForm.resetFields();
		},
		addCancel(){
			this.addShow = false;
			this.radio = '0';
			this.addForm = {};
			this.list = [];
		},
		// 确定
		confirmAdd() {
			this.$refs.addForm.validate(valid => {
				if (valid && this.checkCode(this.addForm.code)) {
					let newList = []
					if(this.radio=='1'){
						newList = this.list.map(item=>{
							return {
								...item,
								status: '1',
								remark: '新增'
							}
						})
					} else {
						newList.push({
							...this.addForm,
							status: '1',
							remark: '新增'
						})
					}
					this.$axios.post('/specialEquipment/timeAndPrice.json', {
						policyTimeType: this.info.policyTimeType,
						beginDate: this.info.beginDate,
						endDate: this.info.endDate,
						detailList: newList
					}).then(res => {
						if(res){
							this.orderData = this.orderData.concat(res.detailList);
							this.$set(this.info, 'price', res.amount);
							this.amount = res.amount;
							this.addCancel();
						}
					})
					this.addCancel();
				}
			})
		},
		// 添加被保公司
		addCompany() {
			if (this.editForm.companyList.length < 5) {
				this.editForm.companyList.push({ name: '' });
			} else {
				this.alert('被保公司数量已达上限（5个）');
			}
		},

		// 删除被保公司
		deleteCompany(index) {
			if (index === 0) {
				this.alert('第一个被保公司不能删除');
				return;
			}
			// this.confirm('确定删除该被保公司？', () => {
				this.editForm.companyList.splice(index, 1);
			// });
		},

		// 确定修改
		confirmEdit() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					// 获取新的被保公司列表
					const newCompanies = this.editForm.companyList.map(company => company.name.trim()).filter(name => name !== '');
					const newCompanyListString = newCompanies.join(',');
					
					// 检查被保公司是否有变更
					if (this.info.companyListString !== newCompanyListString) {
						this.companyEdited = true;
					}
					
					// 立即更新显示值，确保页面展示最新编辑内容
					this.$set(this.info, 'companyListString', newCompanyListString);
					this.editShow = false;
				}
			})
		},
		// 打开编辑设备信息
		openEdit(row, index) {
			this.editDeviceShow = true;
			this.editDeviceForm = this.jsonCopy(row);
			this.editDeviceIndex = index; // 保存当前编辑的索引
		},
		// 取消编辑设备信息
		editCancel(){
			this.editDeviceShow = false;
			this.editDeviceForm = {};
			this.editDeviceIndex = -1;
		},
		// 确认编辑设备信息
		confirmEditDevice() {
			this.$refs.editDeviceForm.validate(valid => {
				if (valid) {
					this.editDeviceLoading = true;
					let newList = [{
						...this.editDeviceForm,
						status: '5'
					}]
					this.$axios.post('/specialEquipment/timeAndPrice.json', {
						policyTimeType: this.info.policyTimeType,
						beginDate: this.info.beginDate,
						endDate: this.info.endDate,
						detailList: newList
					}).then(res => {
						if(res){
							if (!res) return
							let newItem = res.detailList.find(item => {
								return item.code == this.editDeviceForm.code
							})
							this.$set(this.orderData, this.editDeviceIndex, {
								...newItem,
								status: 5,
								remark: '编辑'
							})
							this.$set(this.info, 'price', res.amount);
							this.amount = res.amount;
							this.editDeviceShow = false;
							this.editDeviceLoading = false;
						}
					}).catch(err=>{
						this.editDeviceLoading = false;
					});
				}
			});
		},
		// 撤回
		recall(row, index) {
			let text = ''
			if (row.status == '4') {
				// 批减
				text = '确定撤回批减设备？'
			} else if (row.status == '2') {
				// 替换新增
				text = '确定撤回替换设备？'
			} else if (row.status == '5') {
				// 编辑
				text = '确定撤回编辑设备？'
			}
			
			this.confirm(text, () => {
				if (row.status == '2') {
					// 替换撤回逻辑
					let originalCode = this.orderData[index-1].code;
					let originalIndex = this.originalList.findIndex(item => {
						return item.code == originalCode;
					});
					// 恢复原数据
					this.orderData.splice(index-1, 1, this.originalList[originalIndex]);
					// 删除替换数据
					this.orderData.splice(index, 1);
				} else if (row.status == '4' || row.status == '5') {
					// 批减或编辑撤回逻辑
					let originalCode = row.code;
					let originalIndex = this.originalList.findIndex(item => {
						return item.code == originalCode;
					});
					
					if (originalIndex > -1) {
						// 恢复原始数据
						let originalData = this.jsonCopy(this.originalList[originalIndex]);
						originalData.status = '0'; // 恢复为初始状态
						originalData.remark = ''; // 清空备注
						
						let currentIndex = this.orderData.findIndex(item => {
							return item.code == row.code;
						});
						
						if (currentIndex > -1) {
							this.orderData.splice(currentIndex, 1, originalData);
						}
					}
				}
				
				// 重新计算保费
				this.getPremium();
			});
		},
		// 删除新增
		delList(row,index) {
			this.$Modal.confirm({
				title: '确定删除新增人员？',
				okText:'取消',
				cancelText:'确认',
				onOk: () => {
					
				},
				onCancel: () => {
					this.orderData.splice(index, 1)
					this.getPremium()
				}
			});
		},
		// 批减
		refund(row, index) {
			this.refundData = row;
			this.refundIndex = index;
			// 设置退保日期默认值为当天
			const today = new Date();
			this.refundForm.refundDate = today.toISOString().split('T')[0];
			// 设置日期选择范围：当天至保障止期前一天
			const endDate = new Date(this.info.endDate);
			endDate.setDate(endDate.getDate() - 1);
			this.refundDateOptions = {
				disabledDate: (time) => {
					// 禁用早于今天的日期
					const today = new Date();
					today.setHours(0, 0, 0, 0);
					const isBeforeToday = time.getTime() < today.getTime();
					// 禁用晚于保障止期前一天的日期
					endDate.setHours(23, 59, 59, 999);
					const isAfterEndDate = time.getTime() > endDate.getTime();
					return isBeforeToday || isAfterEndDate;
				}
			};
			this.refundShow = true;
		},
		// 确认退保
		confirmRefund() {
			if (!this.refundForm.refundDate) {
				this.$Message.error('请选择退保日期');
				return;
			}
			this.refundLoading = true;
			let newList = [{
				...this.refundData,
				status: '4',
				endDate: this.formatDate(this.refundForm.refundDate)
			}]
			this.$axios.post('/specialEquipment/timeAndPrice.json', {
				policyTimeType: this.info.policyTimeType,
				beginDate: this.info.beginDate,
				endDate: this.info.endDate,
				detailList: newList
			}).then(res => {
				if(res){
					let newItem = res.detailList.find(item => {
						return item.code == this.refundData.code
					})
					this.orderData.splice(this.refundIndex, 1, {
						...newItem,
						status: '4',
						remark: '批减',
						insuranceStatusName: '批减'
					});
					this.$set(this.info, 'price', res.amount);
					this.amount = res.amount;
				}
				this.refundShow = false;
				this.refundLoading = false;
			}).catch(() => {
				this.refundLoading = false;
			});
		},
		// 打开替换
		openRelace(row) {
			this.replaceShow = true;
			this.replaceData = row;
			this.replaceForm = {};
			this.$refs.replaceForm.resetFields();
		},
		// 确定替换
		confirmReplace() {
			this.$refs.replaceForm.validate(valid => {
				if (valid && this.checkCode(this.replaceForm.code)) {
					// 替换人
					this.replaceLoading = true;
					let newList = [{
						...this.replaceForm,
						refCode: this.replaceData.code,
						status: '2'
					}]
					this.$axios.post('/specialEquipment/timeAndPrice.json', {
						policyTimeType: this.info.policyTimeType,
						beginDate: this.info.beginDate,
						endDate: this.info.endDate,
						detailList: newList
					}).then(res => {
						if(res){
							if (!res) return
							let newItem = res.detailList.find(item => {
								return item.code == this.replaceForm.code
							})
							// 原始数据赋值
							let initIndex = this.orderData.findIndex(item => {
								return item.code == this.replaceData.code
							})
							this.orderData.splice(initIndex + 1, 0, {
								...newItem,
								status: 2,
								remark: '替换',
								insuranceStatusName: '替换',
								refCode: this.replaceData.code
							})
							this.orderData.splice(initIndex, 1, {
								...this.orderData[initIndex],
								premium: '-',
								status: 3,
								remark: '被替换'
							})
							this.$set(this.info, 'price', res.amount);
							this.amount = res.amount;
							this.replaceShow = false;
							this.replaceLoading = false;
						}
					}).catch(err=>{
						this.replaceLoading = false
					});
				}
			})
		},
		confirmMedalCancel(){
			this.correctUrlList = [];
			this.confirmShow = false;
		},
		// 确认跳转
		confirmSub() {
			if(this.correctUrlList.length==0){
				this.alert('请上传批改单！')
				return
			}
			if(this.confirmLoading){
				return
			}
			this.confirmLoading = true;
			// 0-承保
			// 1-新增
			// 2-替换
			// 3-被替换
			// 4-批减
			// 5-编辑
			let list = this.jsonCopy(this.orderData.filter(item => {
				return item.status == '1' || item.status == '2' || item.status == '3' || item.status == '4'|| item.status == '5'
			}))
			if(this.companyEdited){
				// 更新被保公司信息
				const companyNames = this.editForm.companyList.map(company => company.name.trim()).filter(name => name !== '');
				this.$set(this.info, 'companyListString', companyNames.join(','));
			}
			let data = {
				billNo: this.info.billNo,
				detailList: list,
				billType:2,
				policyTimeType: this.info.policyTimeType,
				beginDate: this.info.beginDate,
				endDate: this.info.endDate,
				centerId: this.info.centerId,
				companyListString: this.info.companyListString,
				centerName: this.info.centerName,
				centerUserName: this.info.centerUserName,
				phone: this.info.phone,
				policyNo: this.info.policyNo
			}
			if(this.correctUrlList.length>0){
				data.attachmentUrl = this.correctUrlList.join(',')
			}
			this.$axios.post('/specialEquipment/insurance/save.json',data).then(async res => {
				console.log(res,'baocun')
				// 回溯 停止录制
				await this.stopRecord({
					session_key:sessionStorage.track_session_key,
					policy_id: res
				});
				this.confirmLoading = false;
				this.$router.push(`/forklift/editSuccess/${res}`)
			}).catch(err=>{
				this.confirmLoading = false;
			});
		},
		// 提交
		sub() {
			this.confirm('确定提交信息？', () => {
				const premiumResult = this.getPremium();
				if (premiumResult && typeof premiumResult.then === 'function') {
					premiumResult.then((res) => {
						if (res) {
							this.orderData.forEach((item,index) => {
								res.detailList.forEach((val) => {
									if(item.code==val.code){
										this.$set(this.orderData,index,val)
									}
								})
							})
						}
						this.confirmShow = true;
					})
				} else {
					this.confirmShow = true;
				}
			})
		},
		// 保费计算
		getPremium() {
			let list = this.orderData.filter(item => {
				return item.status == '1' || item.status == '2' || item.status == '3' || item.status == '4'|| item.status == '5'
			})
			if (list.length == 0) {
				this.$set(this.info, 'price', 0);
				this.amount = 0;
				return Promise.resolve(false) // Return a Promise instead of false
			}
			return this.$axios.post('/specialEquipment/timeAndPrice.json.all', {
				policyTimeType: this.info.policyTimeType,
				beginDate: this.info.beginDate,
				endDate: this.info.endDate,
				detailList: list
			}).then(res => {
				if (res.code !== 10000000) {
					this.alert(res.msg)
					return false
				}
				this.$set(this.info, 'price', res.data.amount);
				this.amount = res.data.amount;
				return res.data
			})
		}
	}
}
</script>
<style scoped lang="less">
.main {
	margin-top: 24px;
	min-height: 100vh;
}
.mb0 {
	margin-bottom: 0;
}

.edit-warning {
	font-size: 16px;
	color: red;
	margin-right: 20px;
}

.errorMsg {
	font-size: 16px;
	color: red;
	float: right;
	line-height: 32px;
}
.red{
	color: red;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/edit.vue